import { combineReducers } from "redux";
import profileReducer from "./profileReducer";
import fosaReducer from "./fosaReducer";
import claimReducer from "./claimReducer";
import {invoiceReducer} from "./invoice";

// Import your reducers here
// import exampleReducer from './exampleReducer';

const rootReducer = combineReducers({
  profileReducer,
  fosaReducer,
  claim: claimReducer,
  invoice: invoiceReducer,
  loading: (state = { isLoading: false }, action) => {
    switch (action.type) {
      // Add action types that should trigger loading state here
      case "START_LOADING":
        return { isLoading: true };
      case "STOP_LOADING":
        return { isLoading: false };
      default:
        return state;
    }
  },
});

export default rootReducer;
